import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
import { CopyLinkForProposalModal } from '~/hooks/useOpenCopyLinkModal/CopyLinkForProposalModal';
import { useLocaleKeys } from '~/i18n';
export const CopyLinksModal = (param)=>{
    let { recipients, dismissModal } = param;
    const { t: texts } = useLocaleKeys('components.agreementStudio.silentProposal');
    const { t: commonButtons } = useLocaleKeys('common.buttons');
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'copy_links_confirm'
            },
            secondaryButton: {
                name: 'copy_links_cancel'
            }
        },
        testId: "links-modal",
        title: texts.shareByLink(),
        width: "900px",
        content: /*#__PURE__*/ _jsx(CopyLinkForProposalModal, {
            info: /*#__PURE__*/ _jsx(Typography, {
                align: "left",
                children: texts.copyLinksInfo()
            }),
            recipients: recipients
        }),
        primaryButtonLabel: commonButtons.close(),
        primaryButtonTestId: "links-modal-close",
        onPrimaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal
    });
};
